const SalifySvgIconString = ({
  svgString,
  color,
  fontSize = 24,
}: {
  svgString: string;
  color?: string;
  fontSize?: string | number;
}) => (
  <div
    style={{
      display: "inline-block",
      color: color,
      width: fontSize,
    }}
    dangerouslySetInnerHTML={{ __html: svgString }}
  />
);

export default SalifySvgIconString;
